import { type FC } from 'react';
import Resume from './Resume/resume';

const Home: FC = () => {
  return <Resume />;
};

export default Home;
